module.exports = function () {
    /* Fonctionnement accordion menu en responsive */
    const lis = document.querySelectorAll('.menu-with-accordion .menu-responsive-menu .menu-item-has-children > a');

    if (lis) {
        // Tous les lis avec des submenu
        lis.forEach((li) => {
            li.addEventListener('click', (e) => {
                e.preventDefault();

                li.parentNode.classList.toggle('accordion-hide');
            })
        });
    }
};
